import { render, staticRenderFns } from "./miscFeeCreateList.vue?vue&type=template&id=635ce477&scoped=true"
import script from "./miscFeeCreateList.vue?vue&type=script&lang=js"
export * from "./miscFeeCreateList.vue?vue&type=script&lang=js"
import style0 from "./miscFeeCreateList.vue?vue&type=style&index=0&id=635ce477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ce477",
  null
  
)

export default component.exports